import { NgbDateStruct } from '@cmps/ng-bootstrap';

export function padNum(num: number, width: number): string {
    const numStr = num.toString();
    return numStr.length >= width
        ? numStr
        : `${new Array(width - numStr.length + 1).join('0')}${numStr}`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Util {
    static dateToNgbDate(date: Date | NgbDateStruct): NgbDateStruct {
        if (date instanceof Date && !isNaN(date.getTime())) {
            // https://github.com/ng-bootstrap/ng-bootstrap/blob/1.0.0-alpha.15/src/datepicker/ngb-calendar.ts#L5
            return {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate(),
            };
        }
        if (
            !(date instanceof Date) &&
            date &&
            !isNaN(date.year) &&
            !isNaN(date.month) &&
            !isNaN(date.day)
        ) {
            return { year: date.year, month: date.month, day: date.day };
        }
        return null;
    }

    static dateToDate(date: Date | NgbDateStruct | any, tz?: Date): Date {
        // TODO remove after api returns null dates. mitigate 1900 from widget data when dates are actually null
        if (
            (date instanceof Date && date.getFullYear() === 1900) ||
            (typeof date === 'string' && date.startsWith('1900'))
        ) {
            date = null;
        }
        const newDate = (
            fullYear: number,
            month: number,
            date: number,
            tz?: Date,
        ): Date => {
            const tzd = tz || new Date(fullYear, month, date);
            const mon = month + 1;
            return new Date(
                `${fullYear}-${padNum(mon, 2)}-${padNum(date, 2)}T${padNum(
                    tzd.getUTCHours(),
                    2,
                )}:${padNum(tzd.getUTCMinutes(), 2)}:${padNum(
                    tzd.getUTCSeconds(),
                    2,
                )}.${padNum(tzd.getUTCMilliseconds(), 3)}Z`,
            );
        };
        if (date instanceof Date && !isNaN(date.getTime())) {
            return new Date(date);
        }
        if (
            !(date instanceof Date) &&
            date instanceof Object &&
            !isNaN(date.year) &&
            !isNaN(date.month) &&
            !isNaN(date.day)
        ) {
            // https://github.com/ng-bootstrap/ng-bootstrap/blob/1.0.0-alpha.15/src/datepicker/ngb-calendar.ts#L8
            const d = newDate(date.year, date.month - 1, date.day, tz);
            if (!isNaN(d.getTime())) {
                d.setFullYear(date.year);
                return d;
            }
        }
        const d = new Date(date || '');
        if (!isNaN(d.getTime())) {
            return d;
        }
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    static recursiveReducer<TIn, TOut>(
        input: TIn[],
        output: TOut[],
        config: { output: (i: TIn) => TOut[]; input: (i: TIn) => TIn[] },
    ) {
        if (!input || input.length === 0) return output;
        input.forEach((p) => {
            output = output.concat(config.output(p));
            output = Util.recursiveReducer(config.input(p), output, config);
        });
        return output;
    }
}
